module.exports = __webpack_public_path__ + "assets/img/2.7e132c5e.png";